import React, { useState, useEffect } from 'react';
import './Register.css';
import firebaseApp from '../../firebase/credenciales';
import {
    getAuth,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword
} from "firebase/auth";
import { getFirestore, doc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import userIcon from '../../assets/user.svg';
import keyIcon from '../../assets/IconKey.svg';

const MySwal = withReactContent(Swal);
const auth = getAuth(firebaseApp);

function Register() {
    const firestore = getFirestore(firebaseApp);
    const [errors, setErrors] = useState({ email: "", password: "" });
    const [formValues, setFormValues] = useState({ email: '', password: '', rol: 'user' });
    const [showPassword, setShowPassword] = useState(false);
    const [attempts, setAttempts] = useState(0);
    const [isLocked, setIsLocked] = useState(false);
    const [unlockTime, setUnlockTime] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (isLocked && unlockTime) {
            const now = new Date().getTime();
            const remainingTime = unlockTime - now;

            if (remainingTime > 0) {
                const timeout = setTimeout(() => {
                    setIsLocked(false);
                    setAttempts(0);
                    setUnlockTime(null);
                    MySwal.fire({
                        title: 'Desbloqueo',
                        text: 'Puedes intentar registrar un usuario nuevamente.',
                        confirmButtonText: 'Ok'
                    });
                }, remainingTime);

                return () => clearTimeout(timeout);
            }
        }
    }, [isLocked, unlockTime]);

    async function registrarUsuario(email, password, rol) {
        try {
            const adminUser = auth.currentUser;
            const adminEmail = adminUser.email;
            const adminPassword = "password1234";

            const usuarioFirebase = await createUserWithEmailAndPassword(auth, email, password);

            await setDoc(doc(firestore, `usuarios/${usuarioFirebase.user.uid}`), { correo: email, rol });

            MySwal.fire({
                title: '¡Registro exitoso!',
                text: 'Usuario registrado correctamente.',
                confirmButtonText: 'Ok'
            });

            await signInWithEmailAndPassword(auth, adminEmail, adminPassword);

            navigate('/home');
        } catch (error) {
            const newAttempts = attempts + 1;
            setAttempts(newAttempts);

            if (newAttempts >= 2) {
                setIsLocked(true);
                setUnlockTime(new Date().getTime() + 10 * 60 * 1000);
                MySwal.fire({
                    title: '¡Alerta!',
                    text: 'Demasiados intentos fallidos. No puedes intentar nuevamente hasta pasados 10 minutos.',
                    confirmButtonText: 'Entendido',
                });
            } else {
                MySwal.fire({
                    title: 'Error',
                    text: 'Error al registrar usuario. Por favor intenta de nuevo.',
                    confirmButtonText: 'Intentar de nuevo'
                });
            }
        }
    }

    function submitHandler(e) {
        e.preventDefault();
        if (isLocked) return;

        const { email, password, rol } = formValues;
        setErrors({ email: "", password: "" });
        const emailError = validateEmail(email);
        const passwordError = validatePassword(password);

        if (emailError || passwordError) {
            setErrors({ email: emailError, password: passwordError });
            return;
        }

        registrarUsuario(email, password, rol);
    }

    const validateEmail = (email) => {
        if (!email) {
            return "El correo electrónico es requerido.";
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            return "Por favor ingresa un correo electrónico válido.";
        }
        return "";
    };

    const validatePassword = (password) => {
        if (!password) {
            return "La contraseña es requerida.";
        }
        if (password.length < 6) {
            return "La contraseña debe tener al menos 6 caracteres.";
        }
        return "";
    };

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormValues(prevValues => ({ ...prevValues, [id]: value }));
    };

    const goToRegister = () => {
        navigate('/admin/users/settings');
    };

    return (
        <div className="loginContainer">
            <div className="container">
                <h1 className="title">Registrar nuevo usuario</h1>
                <form onSubmit={submitHandler} className="login-form">
                    <div className="input-group">
                        <input
                            type="email"
                            placeholder="Ingresa tu correo electrónico"
                            id="email"
                            value={formValues.email}
                            onChange={handleChange}
                            autoComplete="off"
                            disabled={isLocked}
                            className="input-field"
                        />
                        {errors.email && <p className="error">{errors.email}</p>}
                        <img src={userIcon} className="input-icon" alt="Email Icon" />
                    </div>

                    <div className="input-group">
                        <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Ingresa tu contraseña"
                            id="password"
                            value={formValues.password}
                            onChange={handleChange}
                            autoComplete="off"
                            className="input-field"
                            disabled={isLocked}
                        />
                        <img src={keyIcon} className="input-icon" alt="Password Icon" />
                        <button
                            type="button"
                            className="eyeButton"
                            onClick={() => setShowPassword(!showPassword)}
                            aria-label="Mostrar u ocultar contraseña"
                        >
                            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                        </button>
                    </div>
                    {errors.password && <p className="error">{errors.password}</p>}

                    <div className="input-group">
                        <select
                            id="rol"
                            value={formValues.rol}
                            onChange={handleChange}
                            className="input-field"
                        >
                            <option value="admin">Administrador</option>
                            <option value="user">Usuario</option>
                        </select>
                    </div>

                    <div className='button-container'>
                        <button type="submit" className="submit-button" disabled={isLocked}>
                            Registrar
                        </button>
                        <button
                            type="button"
                            className="submit-button"
                            onClick={goToRegister}
                        >
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Register;
